import React from 'react';

import './MarvelRivals0to2100RankPicker.sass';

import { injectIntl } from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({ collapsed: '(max-width: 767px)' }, { collapsed: false })
export default class MarvelRivals0to2100RankPicker extends React.PureComponent {
  static describeRank = rank => rank.toString();

  static minValue = 0;
  static maxValue = 2100;

  static getDefaultValue = () => [0, 1500];

  static marks = {
    0: (
      <span>
        0
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--bronze">Bronze 3</span>
      </span>
    ),
    200: (
      <span>
        200
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--bronze">Bronze 1</span>
      </span>
    ),
    500: (
      <span>
        500
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--silver">Silver 1</span>
      </span>
    ),
    800: (
      <span>
        800
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--gold">Gold 1</span>
      </span>
    ),
    1100: (
      <span>
        1100
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--platinum">Platinum 1</span>
      </span>
    ),
    1400: (
      <span>
        1400
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--diamond">Diamond 1</span>
      </span>
    ),
    1700: (
      <span>
        1700
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--grandmaster">GM 1</span>
      </span>
    ),
    2000: (
      <span>
        2000
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--celestial">Cel 1</span>
      </span>
    ),
    2100: (
      <span>
        2100
        <span className="rc-slider-mark-tooltip rc-slider-mark-tooltip--eternal">Eternal</span>
      </span>
    ),
  };

  render() {
    const { intl, collapsed, value, onChange } = this.props;

    return (
      <div>
        <div className="range-inputs">
          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({
                id: 'section.product.rating.current',
              })}
              min={MarvelRivals0to2100RankPicker.minValue}
              max={MarvelRivals0to2100RankPicker.maxValue}
              value={value[0]}
              onChange={newValue => onChange([newValue, value[1]])}
            />
          </div>

          <div className="range-inputs__divider" />

          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({ id: 'section.product.wanted' })}
              min={MarvelRivals0to2100RankPicker.minValue}
              max={MarvelRivals0to2100RankPicker.maxValue}
              value={value[1]}
              onChange={newValue => onChange([value[0], newValue])}
            />
          </div>
        </div>

        {!collapsed && (
          <div className="slider">
            <VariableStepRange
              className="rc-slider-marvel-rivals"
              step={100}
              min={MarvelRivals0to2100RankPicker.minValue}
              max={MarvelRivals0to2100RankPicker.maxValue}
              marks={MarvelRivals0to2100RankPicker.marks}
              value={value}
              onChange={onChange}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/marvelRivals/MarvelRivals0to2100RankPicker.js